import React, {PropsWithChildren, useEffect, useState} from "react";
import {css} from "@emotion/react";

import {borderRadius, calculateRemSize, display, flexAbsoluteCenter} from "@pg-design/helpers-css";

interface IProps extends PropsWithChildren {
    show: boolean;
    delay?: number;
}

export const ReelDetailsCenterFeedback = (props: IProps) => {
    const [canShow, setCanShow] = useState(props.show);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setCanShow(props.show);
        }, props.delay);

        return () => {
            clearTimeout(timeout);
        };
    }, [props.show]);

    return (
        <div css={[wrapperStyle, !canShow && display("none")]}>
            <div css={contentWrapperStyle}>{props.children}</div>
        </div>
    );
};

const wrapperStyle = css`
    position: absolute;
    inset: 0;
    ${flexAbsoluteCenter};
    z-index: 2;
    pointer-events: none;
`;

const contentWrapperStyle = css`
    ${flexAbsoluteCenter};
    background: rgba(255, 255, 255, 0.7);
    ${borderRadius(4)};
    width: ${calculateRemSize(8)};
    height: ${calculateRemSize(8)};
`;
import React, {PropsWithChildren, useEffect, useState} from "react";
import {css} from "@emotion/react";

import {borderRadius, calculateRemSize, display, flexAbsoluteCenter} from "@pg-design/helpers-css";

interface IProps extends PropsWithChildren {
    show: boolean;
    delay?: number;
}

export const ReelDetailsCenterFeedback = (props: IProps) => {
    const [canShow, setCanShow] = useState(props.show);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setCanShow(props.show);
        }, props.delay);

        return () => {
            clearTimeout(timeout);
        };
    }, [props.show]);

    return (
        <div css={[wrapperStyle, !canShow && display("none")]}>
            <div css={contentWrapperStyle}>{props.children}</div>
        </div>
    );
};

const wrapperStyle = css`
    position: absolute;
    inset: 0;
    ${flexAbsoluteCenter};
    z-index: 2;
    pointer-events: none;
`;

const contentWrapperStyle = css`
    ${flexAbsoluteCenter};
    background: rgba(255, 255, 255, 0.7);
    ${borderRadius(4)};
    width: ${calculateRemSize(8)};
    height: ${calculateRemSize(8)};
`;
